import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import auth from './auth';
import participants from './participants';
import interviews from './interviews';
import journeys from './journeys';

export default combineReducers({
  auth,
  participants,
  interviews,
  journeys,

  router: routerReducer,
});



// WEBPACK FOOTER //
// ./src/store/ducks/index.js